import Close from '../../src/legacy/Close';
export default Close;
